// import Vue from "vue"; // Vue 3 doesn't need Vue.set
import { TokenService } from "../../services/storage.service";
import ApiService from "../../services/api.service";
// vue-scrollto replaced with native scrolling

const pageNames = {
	dashboard: ["dashboard"],
	matching: ["matches"],
	requests: ["requests"],
	connections: ["connections"],
	inspiration: ["inspiration"],
	profile: ["account"],
};

const defaultBrandActionUi = {
	showPupup: false,
	doAction: "",
	actionBrandId: null,
	matchBrand: null,
	connectMessage: "Hey there,\nYour brand looks great, let's connect!",
	partnershipInMind: [],
	briefWriterRunId: null,
	showMessageInfo: null,
	previousMessageInfo: null,
	previousMessageActionBrandId: null,
	showReportBrand: null,
	reportMessage: "",
	showBadgeInfo: false,
	badgeInfoKey: "",
	showingToggleShowInfoPupup: false,
	whatPartnershipsDropdown: [],
	source: "",
};

const state = {
	videos: [
		{
			pageNames: pageNames.inspiration, // NEW
			videoId: "r3t7HVFfb6g",
			title: "Pitch to collaborate with another brand",
			type: "youtube",
			slug: "pitch",
		},
		{
			pageNames: pageNames.matching, // NEW
			videoId: "B_YyOgi4vGA", // qXfkLfv83JQ - OLD
			title: "How to use and filter the Matches area",
			type: "youtube",
			slug: "matches-page",
		},
		{
			pageNames: pageNames.matching, // NEW
			videoId: "NeMmYJV5YGc", // RG-QJNKV5dk - OLD
			title: "How to send a Connection request",
			type: "youtube",
			slug: "send-connection-request",
		},
		{
			pageNames: pageNames.requests, // NEW
			videoId: "S4yMsPxvvgo", // CW9CiC-X4yw - OLD
			title: "How to cancel a connection request",
			type: "youtube",
			slug: "cancel-connection-request",
		},
		{
			pageNames: pageNames.requests, // NEW
			videoId: "oIReWNXupD8", //E3s3txYxekk - OLD
			title: "How to respond to a connection request",
			type: "youtube",
			slug: "respond-to-connection-request",
		},
		{
			pageNames: pageNames.connections,
			videoId: "HhgNB1HVv8U",
			title: "How to use the Connections area on PartnerUp",
			type: "youtube",
			slug: "connections-area",
		},
		{
			pageNames: pageNames.inspiration, // NEW
			videoId: "jM0SEnQErbM", // DThcUeKBPok - OLD
			title: "Discover our Inspiration area",
			type: "youtube",
			slug: "inspiration",
		},
		{
			pageNames: pageNames.profile,
			videoId: "y9iNISWfXj0",
			title: "How to update your profile on PartnerUp",
			type: "youtube",
			slug: "update-profile",
		},
	],
	loadingText: "",
	showHeader: true,
	showFooter: true,
	showingModal: false,
	logo: "/partner-up-logo-brown2.svg",
	logoBG: "",
	fullMenu: true,
	mobileMenu: false,
	siteName: "PartnerUp",
	globalMessage: "",
	globalMessageColour: "red",
	globalMessageMeta: {},
	dateFormat: "j M 'y",
	dateTimeFormat: "j M 'y H:i",
	products: {},
	tableSortingInfo: {},
	tableHeadingVisibility: {},
	adminUser: null,
	menuCounts: {},
	welcomeMessage: "",
	subscription: {},
	dashboard: {},
	brand_category: [],
	brand_attributes: [],
	socials: [],
	subscribers: [],
	showWelcome: false,
	userBrands: [],
	brand: "default",
	showFeatureTsCs: false,
	collabInfo: {},
	collabInfoLoaded: false,
	collabInfoLoading: false,
	selectedInspiration: null,
	showUserBrandsHelp: true,
	checkMatchRunUpdated: null,
	checkMatchRunUpdateMessage: "",
	checkMatchRunInfo: { id: 0, brand: 0 },
	whatsNew: [],
	playVideo: null,
	videoTitle: "",
	autoplayVideo: true,
	instructionalTipsStamp: new Date().getTime(),
	instructionalTipsLoading: false,
	instructionalTipsHide: false,
	calendar: {},

	collabExamples: [],
	collabExamplesLoaded: false,
	collabExamplesLoading: false,

	showingSubscriptionPupup: false,
	subscriptionPupupPitchId: null,
	subscriptionPupupTitle: "",
	subscriptionPupupPaymentRedirect: "",
	subscriptionPupupFeatureOnly: null,
	subscriptionPupupPaymentCompleted: 0,
	featureSubmitted: 0,
	/** Incremented when a collab pitch is submitted so views using pitch/opportunities can refetch (e.g. PitchPortal carousel). */
	pitchOpportunitiesRefreshNonce: 0,
	subscriptionPaymentCompleteMessage: "",

	featureOnly: false,
	userLoaded: false,
	userCreated: null,
	userIdentity: {
		initials: TokenService.getInitials() || "",
		name: TokenService.getName() || "",
		firstName: TokenService.getFirstName() || "",
	},

	showingBrandNames: false,
	show_newbie_pupup: false,
	hasOpenedWritingTool: false,

	showDatesOfInterestModal: false,
	datesOfInterestRefreshNonce: 0,
	brandConnectModal: {
		show: false,
		connecteeId: null,
		initialData: null,
		source: "",
	},
	brandConnectEvent: null,
	brandActionUi: { ...defaultBrandActionUi },
	brandActionEvent: null,
	brandConnectFeatureDraft: null,
	brandCardPopup: {
		show: false,
		brand: null,
		userBrand: null,
		buttonDefaults: {},
		fields: {},
		dateOfInterestThumb: "",
		dateOfInterestLabel: "",
		currentUserDateOfInterestIds: [],
		loading: false,
		width: 1200,
		full: true,
		shuffleUp: true,
		source: "",
		paymentRedirect: "",
		subscriptionTitle: "",
		displayMode: "default",
		hideActionButtons: false,
	},
	pitchBrandPopup: {
		show: false,
		pitchId: null,
		pitchData: null,
		source: "",
		returnTo: "",
		paymentRedirect: "",
		scrollToFormOnOpen: false,
	},
	collabHelpNeverDonePopup: {
		show: false,
		source: "",
	},
	collabHelpPopup: {
		show: false,
		source: "",
		brandId: null,
	},
	brandCardPopupEvent: null,
};

// getters
const getters = {};

// actions
const actions = {
	checkMatchRun({ commit, state, dispatch }, payload) {
		if (payload) {
			if (state.checkMatchRunInfo.id === payload && state.checkMatchRunInfo.brand === state.brand) return;

			commit("updateVar", { varName: "checkMatchRunInfo", info: { id: payload, brand: state.brand } });

			setTimeout(() => {
				dispatch("checkMatchRun");
			}, 3000);

			return;
		} else if (!state.checkMatchRunInfo.id) return;

		ApiService.get("matching/run-check/" + state.checkMatchRunInfo.id + "/" + state.checkMatchRunInfo.brand)
			.then((info) => {
				if (info.data.status !== "done") {
					setTimeout(() => {
						dispatch("checkMatchRun");
					}, 3000);
				} else {
					const brand = state.checkMatchRunInfo.brand;

					commit("updateVar", { varName: "checkMatchRunInfo", info: { id: 0, brand: 0 } });

					if (brand === state.brand) {
						commit("updateVar", { varName: "checkMatchRunUpdated", info: new Date() });
						commit("updateVar", { varName: "checkMatchRunUpdateMessage", info: info.data.message });
					} else {
						commit("updateVar", { varName: "checkMatchRunUpdateMessage", info: "" });
					}

					dispatch("loadDashboard", info.data.dashboard);
				}
			})
			.catch((err) => {
				console.error("Error in checkMatchRun:", err);
			});
	},

	updateBrand({ commit }, payload) {
		if (!payload || isNaN(payload)) payload = "default";
		else payload = parseInt(payload);
		commit("updateVar", { varName: "brand", info: payload });
		TokenService.saveBrand(payload);
		ApiService.setHeader();
	},
	loadDashboard({ commit, state, dispatch }, payload) {
		const f = ["menuCounts", "dashboard", "subscription", "userBrands", "whatsNew", "showingBrandNames", "brandInfoPublic"];
		const maybeStartMatchRunPolling = (data) => {
			const pendingRunId = data?.matchRunOutstanding || null;

			// Start polling whenever there's an outstanding match run, regardless of readiness state
			// This handles both initial matching (ready=false) and rematches (ready=true)
			if (pendingRunId) {
				dispatch("checkMatchRun", pendingRunId);
			}
		};

		if (payload) {
			let matched = false;
			f.forEach((n) => {
				if (typeof payload[n] !== "undefined") {
					commit("updateVar", { varName: n, info: payload[n] });
					matched = true;
				}
			});
			maybeStartMatchRunPolling(payload);
			if (matched) return;
		}

		let uri = state.brand === "default" ? "dashboard" : "dashboard/" + state.brand;

		return ApiService.get(uri)
			.then((info) => {
				f.forEach((n) => {
					if (typeof info.data[n] !== "undefined") {
						commit("updateVar", { varName: n, info: info.data[n] });
					}
				});

				if (state.brand === "default" && info.data.userBrands && info.data.userBrands.length > 0) {
					commit("updateVar", { varName: "brand", info: info.data.userBrands[0].id });
				}

				maybeStartMatchRunPolling(info.data);

				if (payload && typeof payload.callback !== "undefined") {
					payload.callback();
				}
			})
			.catch((err) => {
				console.error("Error in loadDashboard:", err);
			});
	},
	loadCollabIdeas({ commit, state }) {
		if (state.collabInfoLoading || state.collabInfoLoaded) return;

		commit("updateVar", { varName: "collabInfoLoading", info: true });

		return ApiService.get("collab")
			.then((info) => {
				commit("updateVar", { varName: "collabInfo", info: info.data });
				commit("updateVar", { varName: "collabInfoLoaded", info: true });
				commit("updateVar", { varName: "collabInfoLoading", info: false });
			})
			.catch((err) => {
				console.error("Error in loadCollabIdeas:", err);
				commit("updateVar", { varName: "collabInfoLoading", info: false });
			});
	},
	loadCollabExamples({ commit, state }) {
		if (state.collabExamplesLoading || state.collabExamplesLoaded) return;

		commit("updateVar", { varName: "collabExamplesLoading", info: true });

		return ApiService.get("collab/examples")
			.then((info) => {
				commit("updateVar", { varName: "collabExamples", info: info.data });
				commit("updateVar", { varName: "collabExamplesLoaded", info: true });
				commit("updateVar", { varName: "collabExamplesLoading", info: false });
			})
			.catch((err) => {
				console.error("Error in loadCollabExamples:", err);
				commit("updateVar", { varName: "collabExamplesLoading", info: false });
			});
	},
	async openOpportunityBrandCardPopup({ state, commit }, { brandId, pitchId }) {
		try {
			if (!state.brand || state.brand === "default") {
				throw new Error("No brand selected");
			}

			commit("updateLoadingText", "Loading brand details...");

			const response = await ApiService.get(`brand/${state.brand}/${brandId}`, {
				params: {
					context: "opportunity",
					pitchId: pitchId,
				},
			});

			commit("openBrandCardPopup", {
				brand: response.data.brand,
				userBrand: response.data.userBrand,
				buttonDefaults: response.data.buttons || {},
				fields: response.data.fields || {},
				source: "pitch",
				full: true,
				shuffleUp: true,
				width: 1200,
				displayMode: "opportunity",
				hideActionButtons: true,
			});
		} catch (err) {
			console.error("Error opening opportunity brand card:", err);
			throw err;
		} finally {
			commit("updateLoadingText", "");
		}
	},

	async openOpportunityBrandCardPopupWithButtons({ state, commit }, { brandId, pitchId }) {
		try {
			if (!state.brand || state.brand === "default") {
				throw new Error("No brand selected");
			}

			commit("updateLoadingText", "Loading brand details...");

			const response = await ApiService.get(`brand/${state.brand}/${brandId}`);

			commit("openBrandCardPopup", {
				brand: response.data.brand,
				userBrand: response.data.userBrand,
				buttonDefaults: response.data.buttons || {},
				fields: response.data.fields || {},
				source: "dashboard",
				full: true,
				shuffleUp: true,
				width: 1200,
				hideActionButtons: false,
			});
		} catch (err) {
			console.error("Error opening opportunity brand card:", err);
			throw err;
		} finally {
			commit("updateLoadingText", "");
		}
	},
};

// mutations
const mutations = {
	showSubscriptionPupup(state, info) {
		state.showingSubscriptionPupup = true;
		state.subscriptionPupupTitle = !!info && !!info.title ? info.title : "";
		state.subscriptionPupupPaymentRedirect = !!info && !!info.paymentRedirect ? info.paymentRedirect : "";
		state.subscriptionPupupPitchId = !!info && !!info.pitchId ? info.pitchId : null;
		state.subscriptionPupupFeatureOnly = !!info && typeof info.featureOnly === "boolean" ? info.featureOnly : null;
	},

	closeSubscriptionPupup(state) {
		state.showingSubscriptionPupup = false;
		state.subscriptionPupupTitle = "";
		state.subscriptionPupupPaymentRedirect = "";
		state.subscriptionPupupFeatureOnly = null;
	},

	subscriptionPupupPaymentComplete(state) {
		state.subscriptionPupupPaymentCompleted++;
	},

	featureSubmit(state) {
		state.featureSubmitted++;
	},

	bumpPitchOpportunitiesRefresh(state) {
		state.pitchOpportunitiesRefreshNonce++;
	},

	toggleFeatureTsCs(state, text) {
		state.showFeatureTsCs = !state.showFeatureTsCs;
	},

	updateLoadingText(state, text) {
		if (typeof text === "boolean" && text) text = "One moment...";

		state.loadingText = text ? text : "";
	},
	printGlobalMessage(state, info) {
		if (info === null || typeof info !== "object") return;
		if (info.message) {
			// Native scrolling replacement for VueScrollTo
			setTimeout(() => {
				const element = document.querySelector("#app");
				if (element) {
					element.scrollIntoView({ behavior: "smooth", block: "start" });
				}
			}, 100);
		}
		if (typeof info.temp === "undefined") TokenService.saveGlobalMessage(info);
		state.globalMessage = info.message;
		state.globalMessageColour = info.colour || "default";
		state.globalMessageMeta = info.meta || {};
	},
	updateVar(state, { varName, info }) {
		state[varName] = info;
	},
	updateUserIdentity(state, identity = {}) {
		const currentIdentity = state.userIdentity || {};
		const updatedIdentity = {
			initials: typeof identity.initials !== "undefined" ? identity.initials : currentIdentity.initials || "",
			name: typeof identity.name !== "undefined" ? identity.name : currentIdentity.name || "",
			firstName: typeof identity.firstName !== "undefined" ? identity.firstName : currentIdentity.firstName || "",
		};

		state.userIdentity = updatedIdentity;
		TokenService.saveInitials(updatedIdentity.initials);
		TokenService.saveName(updatedIdentity.name);
		TokenService.saveFirstName(updatedIdentity.firstName);
	},
	openBrandCardPopup(state, payload = {}) {
		const defaults = {
			show: true,
			brand: null,
			userBrand: null,
			buttonDefaults: {},
			fields: {},
			dateOfInterestThumb: "",
			dateOfInterestLabel: "",
			currentUserDateOfInterestIds: [],
			loading: false,
			width: 1200,
			full: true,
			shuffleUp: true,
			source: "",
			paymentRedirect: "",
			subscriptionTitle: "",
			displayMode: "default",
			hideActionButtons: false,
		};
		state.brandCardPopup = { ...defaults, ...payload, show: true };
	},
	openPitchBrandPopup(state, payload = {}) {
		const defaults = {
			show: true,
			pitchId: null,
			pitchData: null,
			source: "",
			returnTo: "",
			paymentRedirect: "",
			scrollToFormOnOpen: false,
		};
		state.pitchBrandPopup = { ...defaults, ...payload, show: true };
	},
	openCollabHelpNeverDonePopup(state, payload = {}) {
		const defaults = {
			show: true,
			source: "",
		};
		state.collabHelpNeverDonePopup = { ...defaults, ...payload, show: true };
	},
	openCollabHelpPopup(state, payload = {}) {
		const defaults = {
			show: true,
			source: "",
			brandId: null,
		};
		state.collabHelpPopup = { ...defaults, ...payload, show: true };
	},
	updateBrandCardPopup(state, payload = {}) {
		state.brandCardPopup = { ...state.brandCardPopup, ...payload };
	},
	updatePitchBrandPopup(state, payload = {}) {
		state.pitchBrandPopup = { ...state.pitchBrandPopup, ...payload };
	},
	closeBrandCardPopup(state) {
		state.brandCardPopup = {
			...state.brandCardPopup,
			show: false,
			brand: null,
			userBrand: null,
			currentUserDateOfInterestIds: [],
			source: "",
			paymentRedirect: "",
			subscriptionTitle: "",
			displayMode: "default",
			hideActionButtons: false,
		};
		state.brandCardPopupEvent = null;
	},
	closePitchBrandPopup(state) {
		state.pitchBrandPopup = {
			...state.pitchBrandPopup,
			show: false,
			pitchId: null,
			pitchData: null,
			source: "",
			returnTo: "",
			paymentRedirect: "",
			scrollToFormOnOpen: false,
		};
	},
	closeCollabHelpNeverDonePopup(state) {
		state.collabHelpNeverDonePopup = {
			...state.collabHelpNeverDonePopup,
			show: false,
			source: "",
		};
	},
	closeCollabHelpPopup(state) {
		state.collabHelpPopup = {
			...state.collabHelpPopup,
			show: false,
			source: "",
			brandId: null,
		};
	},
	setBrandCardPopupEvent(state, payload) {
		state.brandCardPopupEvent = payload;
	},
	clearBrandCardPopupEvent(state) {
		state.brandCardPopupEvent = null;
	},
	setBrandConnectEvent(state, payload) {
		state.brandConnectEvent = payload;
	},
	clearBrandConnectEvent(state) {
		state.brandConnectEvent = null;
	},
	updateBrandActionUi(state, payload = {}) {
		state.brandActionUi = { ...state.brandActionUi, ...payload };
	},
	resetBrandActionUi(state) {
		state.brandActionUi = { ...defaultBrandActionUi };
	},
	setBrandActionEvent(state, payload) {
		state.brandActionEvent = payload;
	},
	clearBrandActionEvent(state) {
		state.brandActionEvent = null;
	},
	tableSorting(state, { tableName, sortingInfo }) {
		state.tableSortingInfo[tableName] = sortingInfo;

		TokenService.saveTableSorting(state.tableSortingInfo);
	},
	tableHeading(state, { tableName, sortingInfo }) {
		state.tableHeadingVisibility[tableName] = sortingInfo;

		TokenService.saveTableHeadingVisibility(state.tableHeadingVisibility);
	},
	saveAdminUser(state, user) {
		state.adminUser = user;
		TokenService.saveAdminUser(user);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
